<template>
  <a href="javascript:void(0)" class="lo-icon-btn lo-icon-btn--nm-icon-text" @click.prevent="$emit('click')">
    <SVGArrowCircleLeft/>

    <span class="lo-icon-btn__text"
          v-html="text"
    />
  </a>
</template>

<script>

  export default {
    props: {
      text: {
        default: "",
        type: String,
      }
    }
  }
</script>

<style>

</style>
